export const CURRENCIES = ['RUB', 'EUR', 'USD', 'CAD'] as const;

export const LIFETIME_IN_MONTHS = [0, 1, 3, 4, 6, 12];
